const regexp = /^[0-9a-fA-F]{24}$/;

// Based on Mongoose isValidObjectId implementation
// @link https://github.com/Automattic/mongoose/blob/83a89f95e4acc8fdd29c2f2ee6ae0e6bf6add48d/lib/index.js#L947
export default function isObjectId(value: string) {
  return typeof value === 'string' && regexp.test(value);
}
